import React from "react";
import { Navigate } from "react-router-dom";
import { useFallbackRoute } from "./useFallbackRoute.type";

const ForbiddenPage: React.FC = () => {
  const { fallback, loading } = useFallbackRoute();
/* istanbul ignore next */
  const handleReload = () => {
    /* istanbul ignore next */
    globalThis.window.location.reload();
  };

  if (loading || !fallback) return null;

  if (fallback !== "/forbidden") {
    return <Navigate to={fallback} replace />;
  }

  return (
    <div style={{
      height: "calc(100vh)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent:"center"
    }}>
      <h1>403 - Forbidden</h1>
      <p>You dont have permission to access content. Kindly contact administrator if anything goes wrong!</p>

      <button
        onClick={handleReload}
        style={{
          marginTop: "16px",
          padding: "10px 18px",
          cursor: "pointer",
          borderRadius: "6px",
          border: "1px solid #ccc",
          background: "#f5f5f5"
        }}
      >
        Reload Page
      </button>
    </div>
  );
};

export default ForbiddenPage;